
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire94c2"];
var parcelRegister = parcelRequire.register;
parcelRegister("c12lO", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $b5de951a0c1f1198$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $aphAM = parcelRequire("aphAM");
var $lzNIT = parcelRequire("lzNIT");

var $kjB4K = parcelRequire("kjB4K");

var $c6Vcd = parcelRequire("c6Vcd");

var $hRvyQ = parcelRequire("hRvyQ");

var $k2cPa = parcelRequire("k2cPa");

var $lb8pt = parcelRequire("lb8pt");

var $l2CDj = parcelRequire("l2CDj");
var $b5de951a0c1f1198$export$2e2bcd8739ae039 = ()=>{
    const params = (0, $aphAM.useParams)();
    if (![
        "apes",
        "droids"
    ].includes(params.name ?? "")) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Navigate), {
        to: "/404"
    });
    const infoImages = {
        apes: [
            (0, $c6Vcd.default).collection_info.ape,
            (0, $c6Vcd.default).collection_info.ape_placeholder
        ],
        droids: [
            (0, $c6Vcd.default).collection_info.droid,
            (0, $c6Vcd.default).collection_info.droid_placeholder
        ]
    };
    const [tokens, setTokens] = (0, $acw62.useState)([]);
    const [info, setInfo] = (0, $acw62.useState)(undefined);
    const [tokensLoaded, setTokensLoaded] = (0, $acw62.useState)(false);
    (0, $acw62.useEffect)(()=>{
        (0, $kjB4K.default).collection.infoByName(params.name).then((info)=>setInfo(info));
        (0, $kjB4K.default).collection.tokens(params.name).then((tokens)=>setTokens(tokens)).finally(()=>setTokensLoaded(true));
    }, []);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $k2cPa.Page), {
        title: info?.name ? `${info.name} NFT Collection` : "",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "relative flex flex-col max-w-[1920px] w-full mx-auto",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("section", {
                    className: "relative overflow-hidden h-[37.5vw] md:max-h-[25vw]",
                    children: [
                        info && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lb8pt.ProgressiveImg), {
                            src: infoImages[info.name][0],
                            placeholder: infoImages[info.name][1],
                            className: "object-cover w-full h-full brightness-50  max-h-[37.5vw] md:max-h-[min(25vw,480px)]"
                        }),
                        info && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "absolute z-10 top-0 h-full w-full flex flex-col items-center uppercase",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "hidden md:flex flex-row gap-x-3 self-start text-xs lg:text-base p-2 md:p-4 md:px-8 lg:pt-6",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lzNIT.NavLink), {
                                            to: "/collection",
                                            children: "Collection"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "opacity-60",
                                            children: " >"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "opacity-60",
                                            children: [
                                                " ",
                                                info.name
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                                    className: "font-bold text-4xl md:text-7xl p-4 md:px-8 lg:mt-8",
                                    children: info.name
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "flex-1 w-full text-center text-[0.7rem] md:text-base lg:text-xl font-bold p-2 md:p-4 md:px-8 lg:leading-loose",
                                    style: {
                                        background: "linear-gradient(180deg, rgba(21, 18, 24, 0) 0%, #000 100%)"
                                    },
                                    children: [
                                        "SUPPLY: ",
                                        info.supply,
                                        " | LAST MINT: ",
                                        info.days_since_mint,
                                        " DAYS AGO",
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                        "MINT PRICE: ",
                                        info.mint_price,
                                        " SOL | FLOOR PRICE: ",
                                        info.floor_price,
                                        " SOL"
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                !tokensLoaded ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $l2CDj.default), {
                    className: "mx-auto"
                }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hRvyQ.CollectionView), {
                    tokens: tokens
                })
            ]
        })
    });
};

});
parcelRegister("hRvyQ", function(module, exports) {

$parcel$export(module.exports, "CollectionView", () => $955be7a91ea382bc$export$a649aea4dbb75476);

var $ayMG0 = parcelRequire("ayMG0");

var $8Qx3l = parcelRequire("8Qx3l");

var $jEyqx = parcelRequire("jEyqx");
parcelRequire("9QbYS");

var $acw62 = parcelRequire("acw62");

var $kjB4K = parcelRequire("kjB4K");

var $c6Vcd = parcelRequire("c6Vcd");

var $fKno6 = parcelRequire("fKno6");
const $955be7a91ea382bc$export$a649aea4dbb75476 = ({ tokens: tokens, className: className = "" })=>{
    const pageSize = 20;
    const [traits, setTraits] = (0, $acw62.useState)({});
    const [traitsLoaded, setTraitsLoaded] = (0, $acw62.useState)(false);
    const [tokensFiltered, setTokensFiltered] = (0, $acw62.useState)(tokens);
    const [tokensView, setTokensView] = (0, $acw62.useState)(tokensFiltered.slice(0, pageSize));
    const [lastElement, setLastElement] = (0, $acw62.useState)(null);
    const [page, setPage] = (0, $acw62.useState)(0);
    const [sortState, setSortState] = (0, $acw62.useState)({
        operative_id: null,
        rank: null,
        price: -1
    });
    const [operativeTypes, setOperativeTypes] = (0, $acw62.useState)([]);
    const [filteringComplete, setFilteringComplete] = (0, $acw62.useState)(true);
    const [sortingComplete, setSortingComplete] = (0, $acw62.useState)(true);
    (0, $acw62.useEffect)(()=>{
        (0, $kjB4K.default).collection.traits().then((traits)=>setTraits(traits)).finally(()=>setTraitsLoaded(true));
    }, []);
    (0, $acw62.useEffect)(()=>{
        setTokensFiltered(tokens);
        setOperativeTypes(Array.from(new Set(tokens.map((t)=>t.operative_type))));
    }, [
        tokens
    ]);
    (0, $acw62.useEffect)(()=>{
        if (traitsLoaded) setTraits(Object.fromEntries(Object.entries(traits).filter(([group, traits])=>operativeTypes.includes(group) ? true : false)));
    }, [
        operativeTypes,
        traitsLoaded
    ]);
    // State for filters toggle
    const [filterToggleState, setFilterToggleState] = (0, $acw62.useState)([]);
    const toggleFilter = (key, name)=>{
        if (filterToggleState.findIndex(([k, t])=>k == key && t == name) !== -1) setFilterToggleState((prev)=>prev.filter(([k, t])=>!(k == key && t == name)));
        else setFilterToggleState((prev)=>[
                ...prev,
                [
                    key,
                    name
                ]
            ]);
    };
    // Filter icons
    const filterIcons = {
        RARITY: (0, $c6Vcd.default).collection_info.rarity_icon,
        "HEADGEAR MATERIAL": (0, $c6Vcd.default).collection_info.hat_icon,
        "BODY PATTERN": (0, $c6Vcd.default).collection_info.bodypattern_icon,
        "BODY PATTERN COLOR": (0, $c6Vcd.default).collection_info.colordrop_icon,
        "BODY TATTOO": (0, $c6Vcd.default).collection_info.tattoo_icon,
        "TATTOO COLOR": (0, $c6Vcd.default).collection_info.colordrop_icon,
        "SHORTS DESIGN": (0, $c6Vcd.default).collection_info.shorts_icon,
        "SHORTS COLOR": (0, $c6Vcd.default).collection_info.colordrop_icon,
        "SHORTS SECOND COLOR": (0, $c6Vcd.default).collection_info.colordrop_add_icon,
        "SHORTS LOGO": (0, $c6Vcd.default).collection_info.tattoo_icon,
        "SHORTS LOGO COLOR": (0, $c6Vcd.default).collection_info.colordrop_icon,
        "SKIN COLOR": (0, $c6Vcd.default).collection_info.colordrop_icon,
        "DOMINANT COLOR": (0, $c6Vcd.default).collection_info.colordrop_icon,
        "SECONDARY COLOR": (0, $c6Vcd.default).collection_info.colordrop_add_icon,
        "ARMOUR MATERIAL": (0, $c6Vcd.default).collection_info.bodypattern_icon
    };
    const filterBorders = {
        ape: "#C91FFF",
        droid: "#03CEFF"
    };
    // Filtering
    const [traitsFilter, setTraitsFilter] = (0, $acw62.useState)([]);
    const [rarityFilter, setRarityFilter] = (0, $acw62.useState)([]);
    const [operativeTypeFilter, setOperativeTypeFilter] = (0, $acw62.useState)([]);
    const [idFilter, setIdFilter] = (0, $acw62.useState)();
    const [rankFilter, setRankFilter] = (0, $acw62.useState)();
    const filterContainerRef = (0, $acw62.useRef)(null);
    const [filtersVisible, setFiltersVisible] = (0, $acw62.useState)(false);
    const [filterChanged, setFilterChanged] = (0, $acw62.useState)(1);
    (0, $acw62.useEffect)(()=>{
        const media = window.matchMedia("(min-width: 768px)");
        const listener = ()=>setFiltersVisible(media.matches);
        listener();
        window.addEventListener("resize", listener);
        return ()=>window.removeEventListener("resize", listener);
    }, []);
    const applyTraitsFilter = (operativeType, type, value)=>{
        if (traitsFilter.find(([o, t, v])=>o == operativeType && t == type && v == value)) setTraitsFilter((prev)=>prev.filter(([o, t, v])=>!(o == operativeType && t == type && v == value)));
        else setTraitsFilter((prev)=>[
                ...prev,
                [
                    operativeType,
                    type,
                    value
                ]
            ]);
    };
    const applyRarityFilter = (rarity)=>{
        if (rarityFilter.includes(rarity)) setRarityFilter((prev)=>prev.filter((p)=>p !== rarity));
        else setRarityFilter((prev)=>[
                ...prev,
                rarity
            ]);
    };
    const applyOperativeTypeFilter = (rarity)=>{
        if (operativeTypeFilter.includes(rarity)) setOperativeTypeFilter((prev)=>prev.filter((p)=>p !== rarity));
        else setOperativeTypeFilter((prev)=>[
                ...prev,
                rarity
            ]);
    };
    const applySearchFilter = (idOrRank)=>{
        let id;
        let rank;
        if (idOrRank.startsWith("#")) id = idOrRank.slice(1);
        else rank = idOrRank;
        setIdFilter(parseInt(id));
        setRankFilter(parseInt(rank));
    };
    const filterTraits = (tokens, attributeFilter)=>{
        const types = Array.from(new Set(attributeFilter.map(([operativeType, traitType, value])=>traitType)));
        return tokens.filter((t)=>{
            return types.every((type)=>{
                return attributeFilter.some(([operativeType, traitType, value])=>{
                    return operativeType == t.operative_type && traitType == type && t.traits.some((ta)=>ta.type == traitType && ta.value == value);
                });
            });
        });
    };
    const filterRarity = (tokens, rarityFilter)=>{
        return tokens.filter((t)=>{
            if ([
                0,
                2
            ].includes(rarityFilter.length)) return true;
            if (t.is_legendary && rarityFilter.includes("LEGENDARY")) return true;
            if (!t.is_legendary && rarityFilter.includes("COMMON")) return true;
            return false;
        });
    };
    const filterOperativeType = (tokens, operativeTypeFilter)=>{
        return tokens.filter((t)=>{
            if ([
                0,
                2
            ].includes(operativeTypeFilter.length)) return true;
            if (t.operative_type.toUpperCase() === "APE" && operativeTypeFilter.includes("APE")) return true;
            if (t.operative_type.toUpperCase() === "DROID" && operativeTypeFilter.includes("DROID")) return true;
            return false;
        });
    };
    const filterId = (tokens, id)=>{
        return tokens.filter((t)=>t.operative_id.toString() == id.toString());
    };
    const filterRank = (tokens, rank)=>{
        return tokens.filter((t)=>t.rank.toString() == rank.toString());
    };
    const clearFilters = ()=>{
        setTraitsFilter([]);
        setOperativeTypeFilter([]);
        setRarityFilter([]);
        filterContainerRef.current?.querySelectorAll("input[type=checkbox]").forEach((i)=>i.checked = false);
    };
    (0, $acw62.useEffect)(()=>{
        setFilteringComplete(false);
        let filtered = tokens;
        if (traitsFilter.length > 0) filtered = filterTraits(filtered, traitsFilter);
        if (rarityFilter.length > 0) filtered = filterRarity(filtered, rarityFilter);
        if (operativeTypeFilter.length > 0) filtered = filterOperativeType(filtered, operativeTypeFilter);
        if (idFilter) filtered = filterId(filtered, idFilter);
        if (rankFilter) filtered = filterRank(filtered, rankFilter);
        setTokensFiltered(filtered);
        setFilterChanged((prev)=>prev * -1);
        setFilteringComplete(true);
    }, [
        traitsFilter,
        rarityFilter,
        operativeTypeFilter,
        idFilter,
        rankFilter
    ]);
    // Count values per filtering groups
    const traitsCount = (operative_type, type, value)=>{
        let filtered = filterTraits(tokens, traitsFilter.filter(([operativeType, traitType, v])=>traitType != type)).filter((t)=>t.operative_type == operative_type && t.traits.some((ta)=>ta.type == type && ta.value == value));
        filtered = filterRarity(filtered, rarityFilter);
        filtered = filterOperativeType(filtered, operativeTypeFilter);
        if (idFilter) filtered = filterId(filtered, idFilter);
        if (rankFilter) filtered = filterRank(filtered, rankFilter);
        return filtered.length;
    };
    const rarityCount = (rarity)=>{
        let filtered = filterTraits(tokens, traitsFilter);
        filtered = filterOperativeType(filtered, operativeTypeFilter);
        if (idFilter) filtered = filterId(filtered, idFilter);
        if (rankFilter) filtered = filterRank(filtered, rankFilter);
        return filtered.filter((t)=>t.is_legendary && rarity == "LEGENDARY" || !t.is_legendary && rarity == "COMMON" ? true : false).length;
    };
    const operativesCount = (type)=>{
        let filtered = filterTraits(tokens, traitsFilter);
        filtered = filterRarity(filtered, rarityFilter);
        if (idFilter) filtered = filterId(filtered, idFilter);
        if (rankFilter) filtered = filterRank(filtered, rankFilter);
        return filtered.filter((t)=>t.operative_type.toUpperCase() === type).length;
    };
    // Paging
    (0, $acw62.useEffect)(()=>{
        setPage(0);
        setTokensView(tokensFiltered.slice(0, (page + 1) * pageSize));
    }, [
        tokensFiltered
    ]);
    (0, $acw62.useEffect)(()=>{
        setTokensView(tokensFiltered.slice(0, (page + 1) * pageSize));
    }, [
        page
    ]);
    // When last rendered Card appear in view - inc rendered size by pageSize
    (0, $acw62.useEffect)(()=>{
        if (lastElement) {
            const observer = new IntersectionObserver((entries)=>{
                const first = entries[0];
                if (first.isIntersecting) setPage((prev)=>prev + 1);
            });
            observer.observe(lastElement);
            return ()=>{
                observer.unobserve(lastElement);
            };
        }
    }, [
        lastElement
    ]);
    // Sorting
    const sort = (field)=>{
        const current = sortState[field];
        const newSortState = {
            operative_id: null,
            rank: null,
            price: null
        };
        newSortState[field] = current == 1 || current == null ? -1 : 1;
        setSortState(newSortState);
    };
    (0, $acw62.useEffect)(()=>{
        setSortingComplete(false);
        const [field, order] = Object.entries(sortState).filter(([f, o])=>o !== null)[0];
        if (field) setTokensFiltered([
            ...tokensFiltered.sort((a, b)=>{
                // equal items sort equally
                if (a[field] === b[field]) return 0;
                else if (a[field] === null) return 1;
                else if (b[field] === null) return -1;
                else if (order == -1) return a[field] > b[field] ? 1 : -1;
                else return a[field] < b[field] ? 1 : -1;
            })
        ]);
        setSortingComplete(true);
    }, [
        sortState,
        filterChanged
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "flex flex-col w-full max-w-[1920px] mx-auto " + className,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("section", {
                className: "flex flex-col md:flex-row items-center justify-end w-full gap-4 md:py-8 text-xs md:text-base",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "group flex flex-row gap-2 items-center px-4 py-2 rounded-3xl border",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jEyqx.FontAwesomeIcon), {
                                icon: (0, $8Qx3l.faMagnifyingGlass),
                                flip: "horizontal",
                                className: "text-sm"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                maxLength: 6,
                                type: "text",
                                placeholder: "#ID OR RANK",
                                className: "text-sm font-bold bg-transparent focus:outline-none w-full",
                                onChange: (e)=>applySearchFilter(e.target.value)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "flex flex-row gap-x-8 px-4 items-center place-content-center font-bold",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                className: "md:hidden py-3 px-1",
                                onClick: ()=>setFiltersVisible((prev)=>!prev),
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jEyqx.FontAwesomeIcon), {
                                    icon: (0, $8Qx3l.faSliders),
                                    className: "text-base"
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                children: "SORT BY:"
                            }),
                            [
                                [
                                    "operative_id",
                                    "id"
                                ],
                                [
                                    "rank",
                                    "rank"
                                ],
                                [
                                    "price",
                                    "price"
                                ]
                            ].map(([field, name], i)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                    onClick: ()=>sort(field),
                                    className: "flex flex-row items-center gap-x-1",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: `uppercase font-bold ${sortState[field] == 1 && "text-[#D40000]"} ${sortState[field] == -1 && "text-[#00FF90]"}`,
                                            children: name
                                        }),
                                        sortState[field] ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jEyqx.FontAwesomeIcon), {
                                            icon: sortState[field] == -1 ? (0, $8Qx3l.faArrowDown) : (0, $8Qx3l.faArrowUp)
                                        }) : " "
                                    ]
                                }, field))
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "hidden md:block h-0.5 w-3/4 self-end",
                style: {
                    background: "linear-gradient(270deg, #D9D9D9 0%, rgba(217, 217, 217, 0) 100%)"
                },
                children: "\xa0"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: `flex flex-col items-center md:items-start md:flex-row pt-2 md:pl-4 `,
                children: [
                    !filtersVisible ? /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                        className: "py-3 px-1 hidden md:block",
                        onClick: ()=>setFiltersVisible((prev)=>!prev),
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jEyqx.FontAwesomeIcon), {
                            icon: (0, $8Qx3l.faSliders),
                            className: "text-base"
                        })
                    }) : /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        ref: filterContainerRef,
                        className: `${filtersVisible ? "block" : "hidden"}`,
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "flex flex-row justify-between items-center text-xs py-4 px-1",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                        onClick: ()=>setFiltersVisible((prev)=>!prev),
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jEyqx.FontAwesomeIcon), {
                                            icon: (0, $8Qx3l.faSliders),
                                            className: "text-base hidden md:block"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                        onClick: clearFilters,
                                        children: "CLEAR"
                                    })
                                ]
                            }),
                            operativeTypes.length > 1 && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "relative select-none uppercase text-xs flex flex-col m-1",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "absolute top-0 left-0 h-full w-full",
                                        style: {
                                            background: "linear-gradient(99.71deg, #C91FFF -4.52%, #03CEFF 106.52%)"
                                        },
                                        children: "\xa0"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "z-10 bg-[#151218] p-3 m-[1px]",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                onClick: ()=>toggleFilter("", "OPERATIVE_TYPE"),
                                                className: "flex flex-row gap-x-4 items-center cursor-pointer",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                        src: filterIcons.RARITY,
                                                        className: "h-3 w-3"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        className: "flex-1 font-bold",
                                                        children: "OPERATIVE TYPE"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        className: `border-t border-r w-2 h-2  ${filterToggleState.find(([k, t])=>t.toLocaleUpperCase() == "OPERATIVE_TYPE") ? "rotate-[135deg]" : "rotate-45"} transition-transform`,
                                                        children: "\xa0"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: `flex-col gap-y-2 mt-4  ${filterToggleState.find(([k, t])=>t.toLocaleUpperCase() == "OPERATIVE_TYPE") ? "flex" : "hidden"}`,
                                                children: [
                                                    "APE",
                                                    "DROID"
                                                ].map((type)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                                        className: "flex flex-row flex-nowrap gap-x-4 cursor-pointer",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                                type: "checkbox",
                                                                className: "self-center appearance-none h-3 w-3 border checked:bg-[#C91FFF] cursor-pointer",
                                                                onChange: ()=>applyOperativeTypeFilter(type)
                                                            }),
                                                            type,
                                                            " [",
                                                            operativesCount(type),
                                                            "]"
                                                        ]
                                                    }, type))
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "relative select-none uppercase text-xs flex flex-col m-1",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "absolute top-0 left-0 h-full w-full",
                                        style: {
                                            background: "linear-gradient(99.71deg, #C91FFF -4.52%, #03CEFF 106.52%)"
                                        },
                                        children: "\xa0"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "z-10 bg-[#151218] p-3 m-[1px]",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                onClick: ()=>toggleFilter("", "RARITY"),
                                                className: "flex flex-row gap-x-4 items-center cursor-pointer",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                        src: filterIcons.RARITY,
                                                        className: "h-3 w-3"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        className: "flex-1 font-bold",
                                                        children: "RARITY"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        className: `border-t border-r w-2 h-2  ${filterToggleState.find(([k, t])=>t.toLocaleUpperCase() == "RARITY") ? "rotate-[135deg]" : "rotate-45"} transition-transform`,
                                                        children: "\xa0"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: `flex-col gap-y-2 mt-4  ${filterToggleState.find(([k, t])=>t.toLocaleUpperCase() == "RARITY") ? "flex" : "hidden"}`,
                                                children: [
                                                    "COMMON",
                                                    "LEGENDARY"
                                                ].map((rarity)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                                        className: "flex flex-row flex-nowrap gap-x-4 cursor-pointer",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                                type: "checkbox",
                                                                className: "self-center appearance-none h-3 w-3 border checked:bg-[#C91FFF] cursor-pointer",
                                                                onChange: ()=>applyRarityFilter(rarity)
                                                            }),
                                                            rarity,
                                                            " [",
                                                            rarityCount(rarity),
                                                            "]"
                                                        ]
                                                    }, rarity))
                                            })
                                        ]
                                    })
                                ]
                            }),
                            Object.entries(traits).map(([key, group])=>group.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "uppercase text-left pl-1 mt-2",
                                            children: [
                                                key,
                                                "s"
                                            ]
                                        }),
                                        Array.from(new Set(group.map((a)=>a.type))).map((name)=>{
                                            return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "select-none uppercase text-xs border flex flex-col p-3 m-1",
                                                style: {
                                                    borderColor: filterBorders[key]
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                        onClick: ()=>toggleFilter(key, name),
                                                        className: "flex flex-row gap-x-4 items-center cursor-pointer",
                                                        children: [
                                                            filterIcons[name.toUpperCase()] ? /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                                src: filterIcons[name.toUpperCase()],
                                                                className: "h-3 w-3"
                                                            }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jEyqx.FontAwesomeIcon), {
                                                                icon: (0, $8Qx3l.faBars),
                                                                className: "h-3 w-3"
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                className: "flex-1 font-bold",
                                                                children: name
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                className: `border-t border-r w-2 h-2  ${filterToggleState.find(([k, t])=>k == key && t == name) ? "rotate-[135deg]" : "rotate-45"} transition-transform`,
                                                                children: "\xa0"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        className: `flex-col gap-y-2 mt-4  ${filterToggleState.find(([k, t])=>k == key && t == name) ? "flex" : "hidden"}`,
                                                        children: group.filter((a)=>a.type == name).map(({ value: value })=>/*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                                                className: "flex flex-row flex-nowrap gap-x-4 cursor-pointer",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                                        type: "checkbox",
                                                                        className: "self-center appearance-none h-3 w-3 border checked:bg-[#C91FFF] cursor-pointer",
                                                                        onChange: ()=>applyTraitsFilter(key, name, value)
                                                                    }),
                                                                    value,
                                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                                        children: [
                                                                            "[",
                                                                            traitsCount(key, name, value),
                                                                            "]"
                                                                        ]
                                                                    })
                                                                ]
                                                            }, value))
                                                    })
                                                ]
                                            }, name);
                                        })
                                    ]
                                }, key))
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "flex-1",
                        children: [
                            tokensView.length == 0 && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "mt-8 w-full text-center text-gray-400",
                                children: "No operatives found"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "grid grid-cols-1 gap-8 p-4 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5 place-content-start",
                                children: filteringComplete && sortingComplete && tokensView.map((token, index)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $fKno6.CollectionViewCard), {
                                        token: token,
                                        ref: index == tokensView.length - 1 ? setLastElement : null
                                    }, token.operative_id))
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

});
parcelRegister("9QbYS", function(module, exports) {
/**
 * Copyright 2016 Google Inc. All Rights Reserved.
 *
 * Licensed under the W3C SOFTWARE AND DOCUMENT NOTICE AND LICENSE.
 *
 *  https://www.w3.org/Consortium/Legal/2015/copyright-software-and-document
 *
 */ (function() {
    "use strict";
    // Exit early if we're not running in a browser.
    if (typeof window !== "object") return;
    // Exit early if all IntersectionObserver and IntersectionObserverEntry
    // features are natively supported.
    if ("IntersectionObserver" in window && "IntersectionObserverEntry" in window && "intersectionRatio" in window.IntersectionObserverEntry.prototype) {
        // Minimal polyfill for Edge 15's lack of `isIntersecting`
        // See: https://github.com/w3c/IntersectionObserver/issues/211
        if (!("isIntersecting" in window.IntersectionObserverEntry.prototype)) Object.defineProperty(window.IntersectionObserverEntry.prototype, "isIntersecting", {
            get: function() {
                return this.intersectionRatio > 0;
            }
        });
        return;
    }
    /**
 * Returns the embedding frame element, if any.
 * @param {!Document} doc
 * @return {!Element}
 */ function getFrameElement(doc) {
        try {
            return doc.defaultView && doc.defaultView.frameElement || null;
        } catch (e) {
            // Ignore the error.
            return null;
        }
    }
    /**
 * A local reference to the root document.
 */ var document = function(startDoc) {
        var doc = startDoc;
        var frame = getFrameElement(doc);
        while(frame){
            doc = frame.ownerDocument;
            frame = getFrameElement(doc);
        }
        return doc;
    }(window.document);
    /**
 * An IntersectionObserver registry. This registry exists to hold a strong
 * reference to IntersectionObserver instances currently observing a target
 * element. Without this registry, instances without another reference may be
 * garbage collected.
 */ var registry = [];
    /**
 * The signal updater for cross-origin intersection. When not null, it means
 * that the polyfill is configured to work in a cross-origin mode.
 * @type {function(DOMRect|ClientRect, DOMRect|ClientRect)}
 */ var crossOriginUpdater = null;
    /**
 * The current cross-origin intersection. Only used in the cross-origin mode.
 * @type {DOMRect|ClientRect}
 */ var crossOriginRect = null;
    /**
 * Creates the global IntersectionObserverEntry constructor.
 * https://w3c.github.io/IntersectionObserver/#intersection-observer-entry
 * @param {Object} entry A dictionary of instance properties.
 * @constructor
 */ function IntersectionObserverEntry(entry) {
        this.time = entry.time;
        this.target = entry.target;
        this.rootBounds = ensureDOMRect(entry.rootBounds);
        this.boundingClientRect = ensureDOMRect(entry.boundingClientRect);
        this.intersectionRect = ensureDOMRect(entry.intersectionRect || getEmptyRect());
        this.isIntersecting = !!entry.intersectionRect;
        // Calculates the intersection ratio.
        var targetRect = this.boundingClientRect;
        var targetArea = targetRect.width * targetRect.height;
        var intersectionRect = this.intersectionRect;
        var intersectionArea = intersectionRect.width * intersectionRect.height;
        // Sets intersection ratio.
        if (targetArea) // Round the intersection ratio to avoid floating point math issues:
        // https://github.com/w3c/IntersectionObserver/issues/324
        this.intersectionRatio = Number((intersectionArea / targetArea).toFixed(4));
        else // If area is zero and is intersecting, sets to 1, otherwise to 0
        this.intersectionRatio = this.isIntersecting ? 1 : 0;
    }
    /**
 * Creates the global IntersectionObserver constructor.
 * https://w3c.github.io/IntersectionObserver/#intersection-observer-interface
 * @param {Function} callback The function to be invoked after intersection
 *     changes have queued. The function is not invoked if the queue has
 *     been emptied by calling the `takeRecords` method.
 * @param {Object=} opt_options Optional configuration options.
 * @constructor
 */ function IntersectionObserver(callback, opt_options) {
        var options = opt_options || {};
        if (typeof callback != "function") throw new Error("callback must be a function");
        if (options.root && options.root.nodeType != 1 && options.root.nodeType != 9) throw new Error("root must be a Document or Element");
        // Binds and throttles `this._checkForIntersections`.
        this._checkForIntersections = throttle(this._checkForIntersections.bind(this), this.THROTTLE_TIMEOUT);
        // Private properties.
        this._callback = callback;
        this._observationTargets = [];
        this._queuedEntries = [];
        this._rootMarginValues = this._parseRootMargin(options.rootMargin);
        // Public properties.
        this.thresholds = this._initThresholds(options.threshold);
        this.root = options.root || null;
        this.rootMargin = this._rootMarginValues.map(function(margin) {
            return margin.value + margin.unit;
        }).join(" ");
        /** @private @const {!Array<!Document>} */ this._monitoringDocuments = [];
        /** @private @const {!Array<function()>} */ this._monitoringUnsubscribes = [];
    }
    /**
 * The minimum interval within which the document will be checked for
 * intersection changes.
 */ IntersectionObserver.prototype.THROTTLE_TIMEOUT = 100;
    /**
 * The frequency in which the polyfill polls for intersection changes.
 * this can be updated on a per instance basis and must be set prior to
 * calling `observe` on the first target.
 */ IntersectionObserver.prototype.POLL_INTERVAL = null;
    /**
 * Use a mutation observer on the root element
 * to detect intersection changes.
 */ IntersectionObserver.prototype.USE_MUTATION_OBSERVER = true;
    /**
 * Sets up the polyfill in the cross-origin mode. The result is the
 * updater function that accepts two arguments: `boundingClientRect` and
 * `intersectionRect` - just as these fields would be available to the
 * parent via `IntersectionObserverEntry`. This function should be called
 * each time the iframe receives intersection information from the parent
 * window, e.g. via messaging.
 * @return {function(DOMRect|ClientRect, DOMRect|ClientRect)}
 */ IntersectionObserver._setupCrossOriginUpdater = function() {
        if (!crossOriginUpdater) /**
     * @param {DOMRect|ClientRect} boundingClientRect
     * @param {DOMRect|ClientRect} intersectionRect
     */ crossOriginUpdater = function(boundingClientRect, intersectionRect) {
            if (!boundingClientRect || !intersectionRect) crossOriginRect = getEmptyRect();
            else crossOriginRect = convertFromParentRect(boundingClientRect, intersectionRect);
            registry.forEach(function(observer) {
                observer._checkForIntersections();
            });
        };
        return crossOriginUpdater;
    };
    /**
 * Resets the cross-origin mode.
 */ IntersectionObserver._resetCrossOriginUpdater = function() {
        crossOriginUpdater = null;
        crossOriginRect = null;
    };
    /**
 * Starts observing a target element for intersection changes based on
 * the thresholds values.
 * @param {Element} target The DOM element to observe.
 */ IntersectionObserver.prototype.observe = function(target) {
        var isTargetAlreadyObserved = this._observationTargets.some(function(item) {
            return item.element == target;
        });
        if (isTargetAlreadyObserved) return;
        if (!(target && target.nodeType == 1)) throw new Error("target must be an Element");
        this._registerInstance();
        this._observationTargets.push({
            element: target,
            entry: null
        });
        this._monitorIntersections(target.ownerDocument);
        this._checkForIntersections();
    };
    /**
 * Stops observing a target element for intersection changes.
 * @param {Element} target The DOM element to observe.
 */ IntersectionObserver.prototype.unobserve = function(target) {
        this._observationTargets = this._observationTargets.filter(function(item) {
            return item.element != target;
        });
        this._unmonitorIntersections(target.ownerDocument);
        if (this._observationTargets.length == 0) this._unregisterInstance();
    };
    /**
 * Stops observing all target elements for intersection changes.
 */ IntersectionObserver.prototype.disconnect = function() {
        this._observationTargets = [];
        this._unmonitorAllIntersections();
        this._unregisterInstance();
    };
    /**
 * Returns any queue entries that have not yet been reported to the
 * callback and clears the queue. This can be used in conjunction with the
 * callback to obtain the absolute most up-to-date intersection information.
 * @return {Array} The currently queued entries.
 */ IntersectionObserver.prototype.takeRecords = function() {
        var records = this._queuedEntries.slice();
        this._queuedEntries = [];
        return records;
    };
    /**
 * Accepts the threshold value from the user configuration object and
 * returns a sorted array of unique threshold values. If a value is not
 * between 0 and 1 and error is thrown.
 * @private
 * @param {Array|number=} opt_threshold An optional threshold value or
 *     a list of threshold values, defaulting to [0].
 * @return {Array} A sorted list of unique and valid threshold values.
 */ IntersectionObserver.prototype._initThresholds = function(opt_threshold) {
        var threshold = opt_threshold || [
            0
        ];
        if (!Array.isArray(threshold)) threshold = [
            threshold
        ];
        return threshold.sort().filter(function(t, i, a) {
            if (typeof t != "number" || isNaN(t) || t < 0 || t > 1) throw new Error("threshold must be a number between 0 and 1 inclusively");
            return t !== a[i - 1];
        });
    };
    /**
 * Accepts the rootMargin value from the user configuration object
 * and returns an array of the four margin values as an object containing
 * the value and unit properties. If any of the values are not properly
 * formatted or use a unit other than px or %, and error is thrown.
 * @private
 * @param {string=} opt_rootMargin An optional rootMargin value,
 *     defaulting to '0px'.
 * @return {Array<Object>} An array of margin objects with the keys
 *     value and unit.
 */ IntersectionObserver.prototype._parseRootMargin = function(opt_rootMargin) {
        var marginString = opt_rootMargin || "0px";
        var margins = marginString.split(/\s+/).map(function(margin) {
            var parts = /^(-?\d*\.?\d+)(px|%)$/.exec(margin);
            if (!parts) throw new Error("rootMargin must be specified in pixels or percent");
            return {
                value: parseFloat(parts[1]),
                unit: parts[2]
            };
        });
        // Handles shorthand.
        margins[1] = margins[1] || margins[0];
        margins[2] = margins[2] || margins[0];
        margins[3] = margins[3] || margins[1];
        return margins;
    };
    /**
 * Starts polling for intersection changes if the polling is not already
 * happening, and if the page's visibility state is visible.
 * @param {!Document} doc
 * @private
 */ IntersectionObserver.prototype._monitorIntersections = function(doc) {
        var win = doc.defaultView;
        if (!win) // Already destroyed.
        return;
        if (this._monitoringDocuments.indexOf(doc) != -1) // Already monitoring.
        return;
        // Private state for monitoring.
        var callback = this._checkForIntersections;
        var monitoringInterval = null;
        var domObserver = null;
        // If a poll interval is set, use polling instead of listening to
        // resize and scroll events or DOM mutations.
        if (this.POLL_INTERVAL) monitoringInterval = win.setInterval(callback, this.POLL_INTERVAL);
        else {
            addEvent(win, "resize", callback, true);
            addEvent(doc, "scroll", callback, true);
            if (this.USE_MUTATION_OBSERVER && "MutationObserver" in win) {
                domObserver = new win.MutationObserver(callback);
                domObserver.observe(doc, {
                    attributes: true,
                    childList: true,
                    characterData: true,
                    subtree: true
                });
            }
        }
        this._monitoringDocuments.push(doc);
        this._monitoringUnsubscribes.push(function() {
            // Get the window object again. When a friendly iframe is destroyed, it
            // will be null.
            var win = doc.defaultView;
            if (win) {
                if (monitoringInterval) win.clearInterval(monitoringInterval);
                removeEvent(win, "resize", callback, true);
            }
            removeEvent(doc, "scroll", callback, true);
            if (domObserver) domObserver.disconnect();
        });
        // Also monitor the parent.
        var rootDoc = this.root && (this.root.ownerDocument || this.root) || document;
        if (doc != rootDoc) {
            var frame = getFrameElement(doc);
            if (frame) this._monitorIntersections(frame.ownerDocument);
        }
    };
    /**
 * Stops polling for intersection changes.
 * @param {!Document} doc
 * @private
 */ IntersectionObserver.prototype._unmonitorIntersections = function(doc) {
        var index = this._monitoringDocuments.indexOf(doc);
        if (index == -1) return;
        var rootDoc = this.root && (this.root.ownerDocument || this.root) || document;
        // Check if any dependent targets are still remaining.
        var hasDependentTargets = this._observationTargets.some(function(item) {
            var itemDoc = item.element.ownerDocument;
            // Target is in this context.
            if (itemDoc == doc) return true;
            // Target is nested in this context.
            while(itemDoc && itemDoc != rootDoc){
                var frame = getFrameElement(itemDoc);
                itemDoc = frame && frame.ownerDocument;
                if (itemDoc == doc) return true;
            }
            return false;
        });
        if (hasDependentTargets) return;
        // Unsubscribe.
        var unsubscribe = this._monitoringUnsubscribes[index];
        this._monitoringDocuments.splice(index, 1);
        this._monitoringUnsubscribes.splice(index, 1);
        unsubscribe();
        // Also unmonitor the parent.
        if (doc != rootDoc) {
            var frame = getFrameElement(doc);
            if (frame) this._unmonitorIntersections(frame.ownerDocument);
        }
    };
    /**
 * Stops polling for intersection changes.
 * @param {!Document} doc
 * @private
 */ IntersectionObserver.prototype._unmonitorAllIntersections = function() {
        var unsubscribes = this._monitoringUnsubscribes.slice(0);
        this._monitoringDocuments.length = 0;
        this._monitoringUnsubscribes.length = 0;
        for(var i = 0; i < unsubscribes.length; i++)unsubscribes[i]();
    };
    /**
 * Scans each observation target for intersection changes and adds them
 * to the internal entries queue. If new entries are found, it
 * schedules the callback to be invoked.
 * @private
 */ IntersectionObserver.prototype._checkForIntersections = function() {
        if (!this.root && crossOriginUpdater && !crossOriginRect) // Cross origin monitoring, but no initial data available yet.
        return;
        var rootIsInDom = this._rootIsInDom();
        var rootRect = rootIsInDom ? this._getRootRect() : getEmptyRect();
        this._observationTargets.forEach(function(item) {
            var target = item.element;
            var targetRect = getBoundingClientRect(target);
            var rootContainsTarget = this._rootContainsTarget(target);
            var oldEntry = item.entry;
            var intersectionRect = rootIsInDom && rootContainsTarget && this._computeTargetAndRootIntersection(target, targetRect, rootRect);
            var rootBounds = null;
            if (!this._rootContainsTarget(target)) rootBounds = getEmptyRect();
            else if (!crossOriginUpdater || this.root) rootBounds = rootRect;
            var newEntry = item.entry = new IntersectionObserverEntry({
                time: now(),
                target: target,
                boundingClientRect: targetRect,
                rootBounds: rootBounds,
                intersectionRect: intersectionRect
            });
            if (!oldEntry) this._queuedEntries.push(newEntry);
            else if (rootIsInDom && rootContainsTarget) // If the new entry intersection ratio has crossed any of the
            // thresholds, add a new entry.
            {
                if (this._hasCrossedThreshold(oldEntry, newEntry)) this._queuedEntries.push(newEntry);
            } else // If the root is not in the DOM or target is not contained within
            // root but the previous entry for this target had an intersection,
            // add a new record indicating removal.
            if (oldEntry && oldEntry.isIntersecting) this._queuedEntries.push(newEntry);
        }, this);
        if (this._queuedEntries.length) this._callback(this.takeRecords(), this);
    };
    /**
 * Accepts a target and root rect computes the intersection between then
 * following the algorithm in the spec.
 * TODO(philipwalton): at this time clip-path is not considered.
 * https://w3c.github.io/IntersectionObserver/#calculate-intersection-rect-algo
 * @param {Element} target The target DOM element
 * @param {Object} targetRect The bounding rect of the target.
 * @param {Object} rootRect The bounding rect of the root after being
 *     expanded by the rootMargin value.
 * @return {?Object} The final intersection rect object or undefined if no
 *     intersection is found.
 * @private
 */ IntersectionObserver.prototype._computeTargetAndRootIntersection = function(target, targetRect, rootRect) {
        // If the element isn't displayed, an intersection can't happen.
        if (window.getComputedStyle(target).display == "none") return;
        var intersectionRect = targetRect;
        var parent = getParentNode(target);
        var atRoot = false;
        while(!atRoot && parent){
            var parentRect = null;
            var parentComputedStyle = parent.nodeType == 1 ? window.getComputedStyle(parent) : {};
            // If the parent isn't displayed, an intersection can't happen.
            if (parentComputedStyle.display == "none") return null;
            if (parent == this.root || parent.nodeType == /* DOCUMENT */ 9) {
                atRoot = true;
                if (parent == this.root || parent == document) {
                    if (crossOriginUpdater && !this.root) {
                        if (!crossOriginRect || crossOriginRect.width == 0 && crossOriginRect.height == 0) {
                            // A 0-size cross-origin intersection means no-intersection.
                            parent = null;
                            parentRect = null;
                            intersectionRect = null;
                        } else parentRect = crossOriginRect;
                    } else parentRect = rootRect;
                } else {
                    // Check if there's a frame that can be navigated to.
                    var frame = getParentNode(parent);
                    var frameRect = frame && getBoundingClientRect(frame);
                    var frameIntersect = frame && this._computeTargetAndRootIntersection(frame, frameRect, rootRect);
                    if (frameRect && frameIntersect) {
                        parent = frame;
                        parentRect = convertFromParentRect(frameRect, frameIntersect);
                    } else {
                        parent = null;
                        intersectionRect = null;
                    }
                }
            } else {
                // If the element has a non-visible overflow, and it's not the <body>
                // or <html> element, update the intersection rect.
                // Note: <body> and <html> cannot be clipped to a rect that's not also
                // the document rect, so no need to compute a new intersection.
                var doc = parent.ownerDocument;
                if (parent != doc.body && parent != doc.documentElement && parentComputedStyle.overflow != "visible") parentRect = getBoundingClientRect(parent);
            }
            // If either of the above conditionals set a new parentRect,
            // calculate new intersection data.
            if (parentRect) intersectionRect = computeRectIntersection(parentRect, intersectionRect);
            if (!intersectionRect) break;
            parent = parent && getParentNode(parent);
        }
        return intersectionRect;
    };
    /**
 * Returns the root rect after being expanded by the rootMargin value.
 * @return {ClientRect} The expanded root rect.
 * @private
 */ IntersectionObserver.prototype._getRootRect = function() {
        var rootRect;
        if (this.root && !isDoc(this.root)) rootRect = getBoundingClientRect(this.root);
        else {
            // Use <html>/<body> instead of window since scroll bars affect size.
            var doc = isDoc(this.root) ? this.root : document;
            var html = doc.documentElement;
            var body = doc.body;
            rootRect = {
                top: 0,
                left: 0,
                right: html.clientWidth || body.clientWidth,
                width: html.clientWidth || body.clientWidth,
                bottom: html.clientHeight || body.clientHeight,
                height: html.clientHeight || body.clientHeight
            };
        }
        return this._expandRectByRootMargin(rootRect);
    };
    /**
 * Accepts a rect and expands it by the rootMargin value.
 * @param {DOMRect|ClientRect} rect The rect object to expand.
 * @return {ClientRect} The expanded rect.
 * @private
 */ IntersectionObserver.prototype._expandRectByRootMargin = function(rect) {
        var margins = this._rootMarginValues.map(function(margin, i) {
            return margin.unit == "px" ? margin.value : margin.value * (i % 2 ? rect.width : rect.height) / 100;
        });
        var newRect = {
            top: rect.top - margins[0],
            right: rect.right + margins[1],
            bottom: rect.bottom + margins[2],
            left: rect.left - margins[3]
        };
        newRect.width = newRect.right - newRect.left;
        newRect.height = newRect.bottom - newRect.top;
        return newRect;
    };
    /**
 * Accepts an old and new entry and returns true if at least one of the
 * threshold values has been crossed.
 * @param {?IntersectionObserverEntry} oldEntry The previous entry for a
 *    particular target element or null if no previous entry exists.
 * @param {IntersectionObserverEntry} newEntry The current entry for a
 *    particular target element.
 * @return {boolean} Returns true if a any threshold has been crossed.
 * @private
 */ IntersectionObserver.prototype._hasCrossedThreshold = function(oldEntry, newEntry) {
        // To make comparing easier, an entry that has a ratio of 0
        // but does not actually intersect is given a value of -1
        var oldRatio = oldEntry && oldEntry.isIntersecting ? oldEntry.intersectionRatio || 0 : -1;
        var newRatio = newEntry.isIntersecting ? newEntry.intersectionRatio || 0 : -1;
        // Ignore unchanged ratios
        if (oldRatio === newRatio) return;
        for(var i = 0; i < this.thresholds.length; i++){
            var threshold = this.thresholds[i];
            // Return true if an entry matches a threshold or if the new ratio
            // and the old ratio are on the opposite sides of a threshold.
            if (threshold == oldRatio || threshold == newRatio || threshold < oldRatio !== threshold < newRatio) return true;
        }
    };
    /**
 * Returns whether or not the root element is an element and is in the DOM.
 * @return {boolean} True if the root element is an element and is in the DOM.
 * @private
 */ IntersectionObserver.prototype._rootIsInDom = function() {
        return !this.root || containsDeep(document, this.root);
    };
    /**
 * Returns whether or not the target element is a child of root.
 * @param {Element} target The target element to check.
 * @return {boolean} True if the target element is a child of root.
 * @private
 */ IntersectionObserver.prototype._rootContainsTarget = function(target) {
        var rootDoc = this.root && (this.root.ownerDocument || this.root) || document;
        return containsDeep(rootDoc, target) && (!this.root || rootDoc == target.ownerDocument);
    };
    /**
 * Adds the instance to the global IntersectionObserver registry if it isn't
 * already present.
 * @private
 */ IntersectionObserver.prototype._registerInstance = function() {
        if (registry.indexOf(this) < 0) registry.push(this);
    };
    /**
 * Removes the instance from the global IntersectionObserver registry.
 * @private
 */ IntersectionObserver.prototype._unregisterInstance = function() {
        var index = registry.indexOf(this);
        if (index != -1) registry.splice(index, 1);
    };
    /**
 * Returns the result of the performance.now() method or null in browsers
 * that don't support the API.
 * @return {number} The elapsed time since the page was requested.
 */ function now() {
        return window.performance && performance.now && performance.now();
    }
    /**
 * Throttles a function and delays its execution, so it's only called at most
 * once within a given time period.
 * @param {Function} fn The function to throttle.
 * @param {number} timeout The amount of time that must pass before the
 *     function can be called again.
 * @return {Function} The throttled function.
 */ function throttle(fn, timeout) {
        var timer = null;
        return function() {
            if (!timer) timer = setTimeout(function() {
                fn();
                timer = null;
            }, timeout);
        };
    }
    /**
 * Adds an event handler to a DOM node ensuring cross-browser compatibility.
 * @param {Node} node The DOM node to add the event handler to.
 * @param {string} event The event name.
 * @param {Function} fn The event handler to add.
 * @param {boolean} opt_useCapture Optionally adds the even to the capture
 *     phase. Note: this only works in modern browsers.
 */ function addEvent(node, event, fn, opt_useCapture) {
        if (typeof node.addEventListener == "function") node.addEventListener(event, fn, opt_useCapture || false);
        else if (typeof node.attachEvent == "function") node.attachEvent("on" + event, fn);
    }
    /**
 * Removes a previously added event handler from a DOM node.
 * @param {Node} node The DOM node to remove the event handler from.
 * @param {string} event The event name.
 * @param {Function} fn The event handler to remove.
 * @param {boolean} opt_useCapture If the event handler was added with this
 *     flag set to true, it should be set to true here in order to remove it.
 */ function removeEvent(node, event, fn, opt_useCapture) {
        if (typeof node.removeEventListener == "function") node.removeEventListener(event, fn, opt_useCapture || false);
        else if (typeof node.detachEvent == "function") node.detachEvent("on" + event, fn);
    }
    /**
 * Returns the intersection between two rect objects.
 * @param {Object} rect1 The first rect.
 * @param {Object} rect2 The second rect.
 * @return {?Object|?ClientRect} The intersection rect or undefined if no
 *     intersection is found.
 */ function computeRectIntersection(rect1, rect2) {
        var top = Math.max(rect1.top, rect2.top);
        var bottom = Math.min(rect1.bottom, rect2.bottom);
        var left = Math.max(rect1.left, rect2.left);
        var right = Math.min(rect1.right, rect2.right);
        var width = right - left;
        var height = bottom - top;
        return width >= 0 && height >= 0 && {
            top: top,
            bottom: bottom,
            left: left,
            right: right,
            width: width,
            height: height
        } || null;
    }
    /**
 * Shims the native getBoundingClientRect for compatibility with older IE.
 * @param {Element} el The element whose bounding rect to get.
 * @return {DOMRect|ClientRect} The (possibly shimmed) rect of the element.
 */ function getBoundingClientRect(el) {
        var rect;
        try {
            rect = el.getBoundingClientRect();
        } catch (err) {
        // Ignore Windows 7 IE11 "Unspecified error"
        // https://github.com/w3c/IntersectionObserver/pull/205
        }
        if (!rect) return getEmptyRect();
        // Older IE
        if (!(rect.width && rect.height)) rect = {
            top: rect.top,
            right: rect.right,
            bottom: rect.bottom,
            left: rect.left,
            width: rect.right - rect.left,
            height: rect.bottom - rect.top
        };
        return rect;
    }
    /**
 * Returns an empty rect object. An empty rect is returned when an element
 * is not in the DOM.
 * @return {ClientRect} The empty rect.
 */ function getEmptyRect() {
        return {
            top: 0,
            bottom: 0,
            left: 0,
            right: 0,
            width: 0,
            height: 0
        };
    }
    /**
 * Ensure that the result has all of the necessary fields of the DOMRect.
 * Specifically this ensures that `x` and `y` fields are set.
 *
 * @param {?DOMRect|?ClientRect} rect
 * @return {?DOMRect}
 */ function ensureDOMRect(rect) {
        // A `DOMRect` object has `x` and `y` fields.
        if (!rect || "x" in rect) return rect;
        // A IE's `ClientRect` type does not have `x` and `y`. The same is the case
        // for internally calculated Rect objects. For the purposes of
        // `IntersectionObserver`, it's sufficient to simply mirror `left` and `top`
        // for these fields.
        return {
            top: rect.top,
            y: rect.top,
            bottom: rect.bottom,
            left: rect.left,
            x: rect.left,
            right: rect.right,
            width: rect.width,
            height: rect.height
        };
    }
    /**
 * Inverts the intersection and bounding rect from the parent (frame) BCR to
 * the local BCR space.
 * @param {DOMRect|ClientRect} parentBoundingRect The parent's bound client rect.
 * @param {DOMRect|ClientRect} parentIntersectionRect The parent's own intersection rect.
 * @return {ClientRect} The local root bounding rect for the parent's children.
 */ function convertFromParentRect(parentBoundingRect, parentIntersectionRect) {
        var top = parentIntersectionRect.top - parentBoundingRect.top;
        var left = parentIntersectionRect.left - parentBoundingRect.left;
        return {
            top: top,
            left: left,
            height: parentIntersectionRect.height,
            width: parentIntersectionRect.width,
            bottom: top + parentIntersectionRect.height,
            right: left + parentIntersectionRect.width
        };
    }
    /**
 * Checks to see if a parent element contains a child element (including inside
 * shadow DOM).
 * @param {Node} parent The parent element.
 * @param {Node} child The child element.
 * @return {boolean} True if the parent node contains the child node.
 */ function containsDeep(parent, child) {
        var node = child;
        while(node){
            if (node == parent) return true;
            node = getParentNode(node);
        }
        return false;
    }
    /**
 * Gets the parent node of an element or its host element if the parent node
 * is a shadow root.
 * @param {Node} node The node whose parent to get.
 * @return {Node|null} The parent node or null if no parent exists.
 */ function getParentNode(node) {
        var parent = node.parentNode;
        if (node.nodeType == /* DOCUMENT */ 9 && node != document) // If this node is a document node, look for the embedding frame.
        return getFrameElement(node);
        // If the parent has element that is assigned through shadow root slot
        if (parent && parent.assignedSlot) parent = parent.assignedSlot.parentNode;
        if (parent && parent.nodeType == 11 && parent.host) // If the parent is a shadow root, return the host element.
        return parent.host;
        return parent;
    }
    /**
 * Returns true if `node` is a Document.
 * @param {!Node} node
 * @returns {boolean}
 */ function isDoc(node) {
        return node && node.nodeType === 9;
    }
    // Exposes the constructors globally.
    window.IntersectionObserver = IntersectionObserver;
    window.IntersectionObserverEntry = IntersectionObserverEntry;
})();

});

parcelRegister("fKno6", function(module, exports) {

$parcel$export(module.exports, "CollectionViewCard", () => $e51016ba3668f811$export$a8ea72ab3c373580);

var $ayMG0 = parcelRequire("ayMG0");

var $8Qx3l = parcelRequire("8Qx3l");

var $jEyqx = parcelRequire("jEyqx");

var $acw62 = parcelRequire("acw62");

var $lzNIT = parcelRequire("lzNIT");

var $5lnZl = parcelRequire("5lnZl");

var $1COAe = parcelRequire("1COAe");

var $c6Vcd = parcelRequire("c6Vcd");

var $if11p = parcelRequire("if11p");

var $9MIIT = parcelRequire("9MIIT");
const $e51016ba3668f811$export$a8ea72ab3c373580 = /*#__PURE__*/ (0, $acw62.forwardRef)(({ token: token }, ref)=>{
    const navigate = (0, $lzNIT.useNavigate)();
    const [fliped, setFliped] = (0, $acw62.useState)(false);
    const [addressCopied, setAddressCopied] = (0, $acw62.useState)(false);
    const copyClipboard = (e, value)=>{
        e.stopPropagation();
        setAddressCopied(true);
        navigator.clipboard.writeText(value).then(()=>{
            setTimeout(()=>setAddressCopied(false), 500);
        });
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        ref: ref,
        style: {
            background: token.is_legendary ? "linear-gradient(180deg,rgba(255,214,0,0.25) 0%,rgba(175,147,0,0.0625) 117.36%)" : "linear-gradient(180deg, rgba(255, 255, 255, 0.075) 0%, rgba(255, 255, 255, 0) 117.36%)"
        },
        className: `flex h-max flex-col overflow-hidden backdrop-blur-sm border border-[rgba(255,255,255,0.25)] rounded mx-auto md:w-auto`,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "flex flex-row gap-x-1 py-3 px-4 text-sm justify-center items-center relative w-full font-bold",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "flex-1 text-[0.6rem] uppercase whitespace-nowrap",
                        children: [
                            token.is_holder && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jEyqx.FontAwesomeIcon), {
                                icon: (0, $8Qx3l.faCheck),
                                className: "text-green-400 px-1"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                children: token.name
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        title: "Rarity Rank",
                        className: `px-2 min-w-min rounded-xl text-center text-[0.5rem] bg-[#9251FF] leading-relaxed`,
                        children: token.rank
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                        title: "Show Attributes",
                        src: (0, $c6Vcd.default).swap_icon,
                        className: "cursor-pointer ml-4",
                        onClick: ()=>setFliped((prev)=>!prev)
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "flex-1 flex flex-col",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "relative flex flex-row w-full perspective rounded",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: `transition-transform duration-500 cursor-pointer w-full aspect-square bg-black ${fliped ? "-rotate-flip" : "no-flip"}`,
                                onClick: ()=>navigate(`/operative/${token.operative_id}`),
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)($e51016ba3668f811$var$NFTImage, {
                                    token: token
                                })
                            }),
                            token.is_legendary && !fliped && /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                src: (0, $c6Vcd.default).star,
                                title: "Legendary",
                                className: "absolute right-2 top-3 h-5 w-5"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                style: {
                                    background: "linear-gradient(221.43deg, rgba(0, 0, 0, 0.4) -6.16%, rgba(32, 106, 152, 0.4) 123.04%)"
                                },
                                className: `absolute top-0 left-0 transition-transform duration-500 h-full w-full overflow-x-hidden grid grid-cols-2 gap-2 text-xs font-bold p-2 scrollbar-tiny scroll-smooth ${!fliped ? "rotate-flip overflow-y-hidden border-r-[12px] border-transparent" : "no-flip overflow-y-auto"}`,
                                children: token.traits.map((a, i)=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $acw62.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                children: a.type
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "text-right",
                                                children: a.value
                                            })
                                        ]
                                    }, i))
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "flex flex-col gap-2 items-center w-full h-full text-xs",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "flex flex-row gap-x-4 mt-2 items-center justify-center",
                                children: [
                                    [
                                        (0, $if11p.default).solana_fm,
                                        (0, $c6Vcd.default).solanafm_icon
                                    ],
                                    [
                                        (0, $if11p.default).solscan,
                                        (0, $c6Vcd.default).solscan_icon
                                    ],
                                    [
                                        (0, $if11p.default).solana_explorer,
                                        (0, $c6Vcd.default).solanaexplorer_icon
                                    ],
                                    [
                                        (0, $if11p.default).magiceden_nft,
                                        (0, $c6Vcd.default).magiceden_icon
                                    ],
                                    [
                                        (0, $if11p.default).opensea_nft,
                                        (0, $c6Vcd.default).opensea_icon
                                    ],
                                    [
                                        (0, $if11p.default).fractal_nft,
                                        (0, $c6Vcd.default).fractal_icon
                                    ]
                                ].map(([url, icon], i)=>/*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                        target: "blank",
                                        href: url(token),
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                            src: icon,
                                            className: "h-4 rounded"
                                        })
                                    }, i))
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "grid grid-cols-3 w-full px-4 gap-y-4 pt-4 items-start font-bold text-[0.65rem]",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "text-xs",
                                        children: "MINT:"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "col-span-2 cursor-pointer opacity-50 hover:opacity-100 text-right",
                                        title: token.mint,
                                        onClick: (e)=>copyClipboard(e, token.mint),
                                        children: addressCopied ? "copied" : (0, $5lnZl.longStringPreview)(token.mint)
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "text-xs",
                                        children: "HOLDER:"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "col-span-2 flex flex-row flex-wrap gap-2 justify-end",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                title: token.holder_wallet,
                                                className: `flex flex-row items-center gap-1 text-right cursor-pointer`,
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        className: "h-4",
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9MIIT.TopGuildRoleIcon), {
                                                            roles: token.holder_roles
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: "opacity-50 hover:opacity-100",
                                                        children: token.holder?.length > 16 ? (0, $5lnZl.longStringPreview)(token.holder) : token.holder
                                                    })
                                                ]
                                            }),
                                            (token.holder_username || token.holder_discord || token.holder_twitter) && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "flex flex-row gap-2",
                                                children: [
                                                    token.holder_username && /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                        src: (0, $c6Vcd.default).wallet_icon,
                                                        title: token.holder_wallet,
                                                        className: "h-4 w-4"
                                                    }),
                                                    token.holder_discord && /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                        src: (0, $c6Vcd.default).discord_icon,
                                                        title: token.holder_discord,
                                                        className: "h-4 w-4"
                                                    }),
                                                    token.holder_twitter && /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                                        href: `https://twitter.com/${token.holder_twitter}`,
                                                        target: "blank",
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                            src: (0, $c6Vcd.default).twitter_icon,
                                                            title: token.holder_twitter,
                                                            className: "h-4 w-4"
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {})
                                ]
                            }),
                            token.price && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                style: {
                                    background: token.is_legendary ? "rgba(255, 214, 0, 0.25)" : "rgba(255, 255, 255, 0.1)"
                                },
                                className: "flex flex-row py-1 px-3 items-center justify-between w-full h-10",
                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $acw62.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "flex items-center justify-center",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                    className: "inline w-2.5 h-2.5 mx-1",
                                                    src: (0, $c6Vcd.default).sol_symbol
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "text-sm font-bold",
                                                    children: token.price
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                            className: "button-default hover:scale-[102%] duration-75 rounded-md w-max px-10 py-1",
                                            href: `https://magiceden.io/item-details/${token.mint}`,
                                            target: "_blank",
                                            children: "BUY"
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
});

const $e51016ba3668f811$var$skullIcon = new URL((parcelRequire("fAHui"))).href;
const $e51016ba3668f811$var$NFTImage = ({ token: token })=>{
    const [loaded, setLoaded] = (0, $acw62.useState)(false);
    const onLoad = ()=>{
        setLoaded(true);
    };
    (0, $acw62.useEffect)(()=>setLoaded(false), [
        token
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: (0, $1COAe.twMerge)("relative overflow-hidden", !loaded && "bg-white/5 animate-pulse"),
        children: [
            !loaded && /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                src: $e51016ba3668f811$var$skullIcon,
                className: (0, $1COAe.twMerge)("h-20 w-20 absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 opacity-10")
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                src: token.image_url,
                loading: "lazy",
                onLoad: onLoad,
                className: (0, $1COAe.twMerge)(!loaded && "opacity-0")
            })
        ]
    });
};

});
parcelRegister("9MIIT", function(module, exports) {

$parcel$export(module.exports, "TopGuildRoleIcon", () => $58390e2ac7d5504f$export$202290b5a3953a4a);
$parcel$export(module.exports, "default", () => $58390e2ac7d5504f$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $8Qx3l = parcelRequire("8Qx3l");

var $jEyqx = parcelRequire("jEyqx");
const $58390e2ac7d5504f$export$88e5d77f170330e = {
    "Gold Guild": "#eeb802",
    "Platinum Guild": "#b6dfdf",
    "Diamond Guild": "#a27ee0"
};
const $58390e2ac7d5504f$var$Badge = ({ icon: icon, color: color, title: title })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "flex flex-row items-center justify-center py-1 px-2 rounded border border-black border-opacity-50 text-xs max-h-full",
        title: title,
        style: {
            background: color
        },
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jEyqx.FontAwesomeIcon), {
            icon: icon,
            color: color,
            className: "filter brightness-50"
        })
    });
};
const $58390e2ac7d5504f$export$3e92acb23cdb6bf7 = {
    "Beta Tester": /*#__PURE__*/ (0, $ayMG0.jsx)($58390e2ac7d5504f$var$Badge, {
        icon: (0, $8Qx3l.faKey)
    }),
    "Gold Guild": /*#__PURE__*/ (0, $ayMG0.jsx)($58390e2ac7d5504f$var$Badge, {
        icon: (0, $8Qx3l.faCrown),
        color: $58390e2ac7d5504f$export$88e5d77f170330e["Gold Guild"],
        title: "Gold Guild"
    }),
    "Platinum Guild": /*#__PURE__*/ (0, $ayMG0.jsx)($58390e2ac7d5504f$var$Badge, {
        icon: (0, $8Qx3l.faCrown),
        color: $58390e2ac7d5504f$export$88e5d77f170330e["Platinum Guild"],
        title: "Platinum Guild"
    }),
    "Diamond Guild": /*#__PURE__*/ (0, $ayMG0.jsx)($58390e2ac7d5504f$var$Badge, {
        icon: (0, $8Qx3l.faCrown),
        color: $58390e2ac7d5504f$export$88e5d77f170330e["Diamond Guild"],
        title: "Diamond Guild"
    }),
    "BR1 Racer": /*#__PURE__*/ (0, $ayMG0.jsx)($58390e2ac7d5504f$var$Badge, {
        icon: (0, $8Qx3l.faPersonRunning)
    })
};
const $58390e2ac7d5504f$export$202290b5a3953a4a = ({ roles: roles })=>{
    const list = [
        "Diamond Guild",
        "Platinum Guild",
        "Gold Guild"
    ];
    for (const entry of list){
        if (roles.includes(entry)) return $58390e2ac7d5504f$export$3e92acb23cdb6bf7[entry];
    }
};
var $58390e2ac7d5504f$export$2e2bcd8739ae039 = ({ roles: roles })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "flex flex-col gap-2 p-4",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("header", {
                className: "font-bold",
                children: "ROLES"
            }),
            roles.map((role)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "flex flex-row gap-2 items-center justify-center overflow-auto rounded-lg p-2 text-center",
                    style: {
                        background: "rgba(21, 18, 24, 0.52)"
                    },
                    children: [
                        $58390e2ac7d5504f$export$3e92acb23cdb6bf7[role],
                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            children: role
                        })
                    ]
                }, role))
        ]
    });
};

});

parcelRegister("fAHui", function(module, exports) {
module.exports = new URL("android-chrome-192x192.80eb3d4c.png", import.meta.url).toString();

});





//# sourceMappingURL=collection.a37c648b.js.map
